import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { QueryStrings } from "src/app/models/emitter-events.models";
import { MissingInspection } from "src/app/models/inspection.model";
import { MissingInspectionsService } from "src/app/services/missing-inspections/missing-inspections.service";

export class MissingInspectionStateModel {
	missingInspectionsListCount: number;
	missingInspectionsList: MissingInspection[];
	update: number;
}

const missingInspectionStateDefaults: MissingInspectionStateModel = {
	missingInspectionsListCount: 0,
	missingInspectionsList: [],
	update: 0,
};

export class GetMissingInspectionsList {
	static readonly type = "[Missing Inspection List View] Get Missing Inspections";
	constructor(public companyId: string, public query: QueryStrings, public isOldMIR: boolean) {}
}

@Injectable()
@State<MissingInspectionStateModel>({
	name: "missingInspectionList",
	defaults: missingInspectionStateDefaults,
})
export class MissingInspectionsState {
	constructor(private missingInspectionsService: MissingInspectionsService) {}

	@Selector()
	static getMissingInspectionsListCount(state: MissingInspectionStateModel) {
		return state.missingInspectionsListCount;
	}

	@Selector()
	static getMissingInspectionsList(state: MissingInspectionStateModel) {
		return state.missingInspectionsList;
	}

	@Selector()
	static missingInspectionsUpdate(state: MissingInspectionStateModel) {
		return state.update;
	}

	@Action(GetMissingInspectionsList)
	getMissingInspectionsList(
		{ patchState, getState }: StateContext<MissingInspectionStateModel>,
		{ companyId, query, isOldMIR }: GetMissingInspectionsList,
	) {
		return this.missingInspectionsService.getMissingInspections(companyId, query, isOldMIR).pipe(
			tap((response: HttpResponse<MissingInspection[]>) => {
				patchState({
					missingInspectionsList: response.body,
					missingInspectionsListCount: parseInt(response.headers.get("x-total-count"), 10),
					update: getState().update + 1,
				});
			}),
		);
	}
}
